<template>
	<DataTable
		:value="files"
		:loading="loading"
		class="p-datatable-sm editable-cells-table"
		:autoLayout="true"
		columnResizeMode="fit"
		@row-dblclick="openEditDialog($event.data)"
	>
		<template #loading>
			{{  $t('Squeeze.General.Loading') }}
		</template>
		<template #empty>
			{{  $t('Squeeze.General.NoEntriesFound', { entryName: $t('Squeeze.Imports.FileSystemImport') }) }}
		</template>
		<template #footer>
			<Button :label="$t('Squeeze.General.NewEntry')" type="button" icon="mdi mdi-plus" class="p-button" @click="onNewEntryClick" />
		</template>
		<!--<Column field="id" header="ID" :sortable="false" class="id-column" />-->
		<!--Column field="batchClassId" :header="$t('Squeeze.BatchClasses.BatchClass')" :sortable="false" /-->
		<Column field="documentClassId" :header="$t('Squeeze.Validation.Dialogs.ChangeDocumentClass.DocumentClass')" :sortable="false">
			<template #body="slotProps">
				{{getDescriptionFromDocumentClass(slotProps.data.documentClassId)}}
			</template>
		</Column>
		<Column field="active" :header="$t('Squeeze.Imports.Active')" :sortable="false">
			<template #body="slotProps">
				{{$t("Squeeze.General.Boolean." + slotProps.data.active)}}
			</template>
		</Column>
		<Column field="path" :header="$t('Squeeze.Imports.Path')" :sortable="false" />
		<Column field="indexFileType" :header="$t('Squeeze.Imports.FileType')" :sortable="false" />
		<Column field="indexFileExtension" :header="$t('Squeeze.Imports.IndexFileExtension')" :sortable="false" />
		<Column field="signalFileName" :header="$t('Squeeze.Imports.FileName')" :sortable="false" />
		<Column field="imageFileExtension" :header="$t('Squeeze.Imports.ImageFileExtension')" :sortable="false" />
		<!-- Bearbeiten / Löschen -->
		<Column class="buttonColumn">
			<template #body="files">
				<Button v-tooltip="$t('Squeeze.Locators.Edit')" icon="mdi mdi-pencil-outline" class="p-button-lg p-button-rounded p-button-success p-button-text" @click="openEditDialog(files.data)" />
				<Button v-tooltip="$t('Squeeze.Validation.Buttons.Delete')" icon="mdi mdi-delete-outline" class="p-button-lg p-button-rounded p-button-danger p-button-text" @click="openDeleteDialog(files.data)" />
			</template>
		</Column>
	</DataTable>
</template>

<script lang="ts">
import {getTranslatedDescription} from "@/util/TranslationHelper";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import {defineComponent, PropType} from "vue";
import {BatchClassClassification, FileImportConfig} from "@dex/squeeze-client-ts";
import {useI18n} from "vue-i18n";

export default defineComponent({
	name: "FileSystem",
	components: {
		DataTable, Column,
	},
	props: {
		files: {
			type: Array as PropType<FileImportConfig[]>,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		documentClasses: {
			type: Array as PropType<BatchClassClassification[]>,
			default: () => [],
			required: true,
		},
		showErrorMessage: {
			type: Boolean,
		},
	},
	emits: [
		"onClickDelete", "onEntrySelect",
	],
	setup(props, {emit}) {
		const {t} = useI18n();
		/**
		 * Opens the Delete-Dialog
		 * @param row The row to delete
		 */
		const openDeleteDialog = (row: FileImportConfig) => {
			emit("onClickDelete", row);
		}

		/** Triggered when the New Entry Button is clicked */
		const onNewEntryClick = () => {
			emit("onEntrySelect", {
				id: undefined,
				batchClassId: undefined,
				documentClassId: 0,
				active: true,
				path: '',
				indexFileType: FileImportConfig.IndexFileTypeEnum.SCM,
				indexFileExtension: '',
				signalFileName: '',
				imageFileExtension: FileImportConfig.ImageFileExtensionEnum.PDF,
			})
		}

		/**
		 * Triggered when the New Entry Button is clicked
		 * @param row The row to edit
		 */
		const openEditDialog = (row: FileImportConfig) => {
			emit("onEntrySelect", row)
		}

		/**
		 * Gets the Description of a documentClass
		 * @param documentClassId Id of the documentClass to get the Description from
		 * @return Description of the documentClass
		 */
		const getDescriptionFromDocumentClass = (documentClassId: number) => {
			if (documentClassId == null) {
				return t('Squeeze.General.None');
			}

			const documentClassDescription = props.documentClasses.find(i => i.documentClassId === documentClassId);

			if (!documentClassDescription) {
				return String(documentClassId)
			}

			return getTranslatedDescription(documentClassDescription)
		}

		return {
			openDeleteDialog, onNewEntryClick, openEditDialog, getDescriptionFromDocumentClass,
		}
	},
});

</script>

<style scoped>

/*::v-deep(td.id-column) {
	width: 5rem;
}*/

</style>
